export default {
  member: [
    {
      icon: 'fa fa-address-card',
      label: 'data.profile',
      route: {
        name: 'member.profile',
      },
    },
    {
      icon: 'fa fa-key',
      label: 'member.action.reset-password',
      route: {
        name: 'member.console-reset-password',
      },
    },
  ],
  admin: [
    {
      icon: 'fa fa-comment-dots',
      label: '訊息中心',
      group: [
        {
          label: 'page.customer-service',
          route: {
            name: 'admin.customer-service-list',
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_MESSAGE'],
        },
        {
          label: 'page.customer_service_faq',
          route: {
            name: 'admin.customer-service-faq-list',
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_MESSAGE'],
        },
        {
          label: 'page.representation',
          route: {
            name: 'admin.representation-list',
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_MESSAGE'],
        },
        {
          label: 'page.visit',
          route: {
            name: 'admin.visit-list',
            query: {
              page: 1,
              sort: 'date=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_MESSAGE'],
        },
        {
          label: 'page.visit-schedule',
          route: {
            name: 'admin.visit-schedule',
          },
          roles: ['ROLE_ADMIN', 'ROLE_MESSAGE'],
        },

        {
          label: 'page.custom-html-content',
          route: {
            name: 'admin.config.custom-html-content',
          },
          roles: ['ROLE_ADMIN', 'ROLE_MESSAGE'],
        },

        {
          label: 'page.customer-service-etc-config',
          route: {
            name: 'admin.config.customer-service-etc-config',
          },
          roles: ['ROLE_ADMIN', 'ROLE_MESSAGE'],
        },
      ],
    },

    {
      icon: 'fa fa-user-circle',
      label: 'module.member',
      group: [
        {
          create: (getRestrict) => !!getRestrict('member.status'),
          label: '會員名單',
          route: {
            name: 'admin.member-list',
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_MEMBER'],
        },
        {
          create: (getRestrict) => !!getRestrict('member.status'),
          label: '已刪除會員',
          route: {
            name: 'admin.member-trashed-list',
            query: {
              page: 1,
              sort: 'deleted_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_MEMBER'],
        },
        {
          label: 'page.push',
          route: {
            name: 'admin.push-list',
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_MEMBER'],
        },
        {
          create: (getRestrict) => !!getRestrict('member.status'),
          label: 'page.member.config',
          route: {
            name: 'admin.config.member',
          },
          roles: ['ROLE_MAINTAINER'],
        },
        {
          create: (getRestrict) => !!getRestrict('member.status'),
          label: 'page.customer-service.config',
          route: {
            name: 'admin.config.customer-service',
          },
          roles: ['ROLE_MAINTAINER', 'ROLE_ADMIN', 'ROLE_MEMBER'],
        },
        {
          create: (getRestrict) => !!getRestrict('member.status'),
          label: 'page.representation.config',
          route: {
            name: 'admin.config.representation',
          },
          roles: ['ROLE_MAINTAINER', 'ROLE_ADMIN', 'ROLE_MEMBER'],
        },
        {
          create: (getRestrict) => !!getRestrict('member.status'),
          label: 'page.visit.config',
          route: {
            name: 'admin.config.visit',
          },
          roles: ['ROLE_MAINTAINER', 'ROLE_ADMIN', 'ROLE_MEMBER'],
        },
        {
          create: (getRestrict) => !!getRestrict('member.status'),
          label: 'page.order.config',
          route: {
            name: 'admin.config.order-notification',
          },
          roles: ['ROLE_MAINTAINER', 'ROLE_ADMIN', 'ROLE_MEMBER'],
        },
      ],
    },
  ],
}